// extracted by mini-css-extract-plugin
module.exports = {"shimmerEffect":"Skeleton_shimmerEffect__3gq41","shimmer":"Skeleton_shimmer__TFY5P","white":"Skeleton_white__PdH0q"};